import { getStaketxlist } from '@/api';
import { echartslineColor, formatNumber } from '@/tool/utils';
import moment from 'moment';
import { useEffect, useState } from 'react';
import CardHead from '../cardHead';
import Echarts from '../echarts';
import LoadingOutlined from '../loadingOutlined';
import PricePanel from '../pricePanel';
import './index.scss';

const types = ["1D", "1W", "1M"]

export default function Index() {
    const [typevlue, setTypeValue] = useState<string>("1D")


    const [updateTime, setUpdateTime] = useState<any>();
    const [yData, setYData] = useState<any>();
    const [echartList, setEchartList] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [txCount, settTxCount] = useState<number>()

    useEffect(() => {
        setLoading(true)
        let param = {
            cycle: 4,
            limit: 24
        }
        if (typevlue == "1D") {
            param = {
                cycle: 4,
                limit: 24
            }
        } else if (typevlue == "1W") {
            param = {
                cycle: 1,
                limit: 7
            }
        } else if (typevlue == "1M") {
            param = {
                cycle: 1,
                limit: 31
            }
        }
        getStaketxlist(param.cycle, undefined, param.limit).then((res) => {
            if (res.data.status == "80000") {
                const data = res.data.data;
                setUpdateTime(data.info.updateTime); 

                settTxCount(data.info.txCount);
                setYData(data.list[0].stakeTxs.yData);
                const list = data.list.map((item: any, index: number) => {
                    item.color = echartslineColor[index];
                    item.name = item.chainName;
                    item.data = item.stakeTxs.data.map((item: any) => {
                        return Number(item)
                    });
                    item.type = 'line';
                    return item
                })
                setEchartList(list)
            }
        }).finally(() => {
            setLoading(false)
        })
    }, [typevlue])

    return <div className="stakedTransactionsValueContainer">
        <CardHead title="Staked Transactions" tips={`Staked transactions in all the StaFi Appchains.`} />
         <PricePanel text={<LoadingOutlined spin={loading}>{formatNumber(txCount, { decimals: 2 })}</LoadingOutlined>} color="green" />
        <Echarts selectType="day" hiddenZoom={true} types={types} onTypeChange={(value: string) => {
            setTypeValue(value)
        }} typeValue={typevlue} updateTime={updateTime} yData={yData} datas={echartList} loading={loading} />
    </div>
}